export const BrandName = () => (
    <div className="nav__brand">
        <span className="nav__brand__tag-1">world</span>
        <span className="nav__brand__tag-2">auto.ge</span>
    </div>
);
